var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export const checkForErrors = (response) => {
    if (['error', 'failures_detected', 'warnings', '_warnings'].some((key) => {
        if (key.includes('warnings')) {
            return Boolean(response.data[key]) && response.data[key].length;
        }
        return Boolean(response.data[key]);
    }) ||
        response.status > 399) {
        const { status: rootStatus } = response;
        // report `warnings` to sdk consumers as `_warnings`
        // concat `warnings` & `_warnings` if necessary
        if (Array.isArray(response.data._warnings)) {
            if (Array.isArray(response.data.warnings)) {
                response.data.warnings = [
                    ...response.data.warnings,
                    ...response.data._warnings
                ];
            }
            else {
                response.data.warnings = response.data._warnings;
            }
        }
        const _a = response.data, { error, failures_detected, status: dataStatus, warnings } = _a, restData = __rest(_a, ["error", "failures_detected", "status", "warnings"]);
        const status = dataStatus !== null && dataStatus !== void 0 ? dataStatus : rootStatus;
        const result = {
            error,
            failures_detected,
            status,
            warnings,
            data: restData
        };
        throw new SearchServiceException(result);
    }
    // We aren't interested in these 'error' fields if we're not in an 'error' state
    delete response.data.warnings;
    delete response.data._warnings;
    delete response.data.failures_detected;
    return response;
};
export class SearchServiceException {
    constructor({ error, failures_detected, status, warnings, data }) {
        if (error)
            this.error = error;
        if (failures_detected)
            this.failures_detected = failures_detected;
        if (status)
            this.status = status;
        if (warnings)
            this.warnings = warnings;
        if (data)
            this.data = data;
    }
    toString() {
        return JSON.stringify(this, null, 2);
    }
}
//# sourceMappingURL=error.js.map